import { gettext as _ } from 'core/utils';
import * as R from 'ramda';

// Sync:
export const required = (value) => (!!value ? undefined : _('Required'));

// Async:
export const asyncValidate = (updateField, result, values, dispatch, form, fieldName) =>
  updateField(R.pick([fieldName], values));
